import { useQuery } from '@tanstack/react-query';
import { getAllDiagnosis, getDiagnosisByIds } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useAllDiagnosisQuery = (opts?: BaseQueryOpts) => {
  return useQuery([ 'diagnosis' ], async () => {
    const diagnosisResponse = await getAllDiagnosis();

    return diagnosisResponse.data;
  }, opts);
};

export const useDiagnosesByIdsQuery = (diagnosisIds: string[], opts?: BaseQueryOpts) => {
  return useQuery([ 'diagnoses', diagnosisIds ], async () => {
    try {
      const diagnoses = await getDiagnosisByIds(diagnosisIds);

      return diagnoses.data;
    } catch (error) {
      console.error(error);
      return;
    }
  }, opts);
};
